@if (visibleFaqs().length) {
  <section
    class="p-4 tablet:p-5 desktop:p-6 desktop:mx-auto bg-white pb-[22px] desktop:pb-[30px] desktop:max-w-6.5xl"
    [ngClass]="{ 'tablet:mx-8': isFaqPage }"
    [id]="data().title"
  >
    <h2
      class="mb-4 text-mobileH2 tablet:text-tabletH2 font-headline desktop:text-desktopH2 tablet:mb-5 desktop:mb-6"
    >
      {{ data().title }}
    </h2>
    <p class="mb-3 font-light">
      {{ data().subTitle }}
    </p>
    <dl class="divide-y divide-[#F1EDED]" aria-live="polite">
      @for (faqItem of displayedFaqs(); track $index) {
        <sc-faq-item-widget class="block" [faqItem]="faqItem"></sc-faq-item-widget>
      }
      <div
        class="border-t border-[#F1EDED]"
        [ngClass]="{
          hidden:
            !displayedFaqs().length ||
            isAllDisplayed() ||
            visibleFaqs().length <= minDisplayedItems,
        }"
      ></div>
    </dl>
    @if (visibleFaqs().length > minDisplayedItems) {
      <div class="flex justify-center mt-6">
        <sc-button
          variant="text"
          [ariaLabel]="isAllDisplayed() ? 'show less faqs' : 'show more faqs'"
          (click)="loadMore()"
          [attr.aria-expanded]="isAllDisplayed()"
        >
          <div
            class="text-mobileButton tablet:text-tabletButton desktop:text-desktopButton mr-1 text-black"
          >
            {{
              (isAllDisplayed() ? 'shared.showLessFaq' : 'shared.seeAllFaq') | scTranslate | async
            }}
          </div>
          @if (isAllDisplayed()) {
            <sc-svg name="minus" size="w-5 h-5"></sc-svg>
          } @else {
            <sc-svg name="plus" size="w-5 h-5"></sc-svg>
          }
        </sc-button>
      </div>
    }
  </section>
}
